import { FC } from 'react';

import { Digest } from '@/components/Digest/Digest';
import { LandingApi } from '@/types/api/landing';

type Props = {
	data: LandingApi.CompanyLandingInfoResponse[];
};

export const DigestPage: FC<Props> = () => {
	return <Digest />;
};

export default DigestPage;
